import { ClientEndpointType, Devices, LuxcomClientEndpoint, useAuth } from "@app/shared";
import { useCallback, useEffect, useMemo } from "react";
import { useFetch, useModel } from "@app/shared/src/hooks";
import { HoverTooltip } from "@app/dashboard/src/components/shared/HoverTooltip";
import { Input, InputRow, Select } from "@app/dashboard/src/components/shared/inputs";
import { ClientEndpointEditorProps } from "./ClientEndpointEditor";

type EditLuxcomClientEndpointProps = {
} & ClientEndpointEditorProps;

export const EditLuxcomClientEndpoint: React.FC<EditLuxcomClientEndpointProps> = (props) => {
    const [luxcomEndpoint, helper] = useModel(LuxcomClientEndpoint, props.endpoint as LuxcomClientEndpoint);
    const { currentOrganizationId } = useAuth();
    const [devices] = useFetch(() => Devices.getByOrganizationId(currentOrganizationId), [currentOrganizationId]);
    const deviceOptions = useMemo(() => !devices?.length ? [] : devices.sort((a, b) => a.name.localeCompare(b.name))?.map(d => ({ label: `${d.name}   (${d.ipv4Address})`, value: d.id! })), [devices]);
    const onChange = useCallback((newEndpoint: Partial<LuxcomClientEndpoint>) => {
        props.onChange({ ...newEndpoint as LuxcomClientEndpoint, endpointType: ClientEndpointType.Luxcom });
    }, [props]);

    const onChangeControllingDevice = useCallback((newEndpoint: Partial<LuxcomClientEndpoint>) => {
        var ip = devices?.find(d => d.id === newEndpoint.controllingDeviceId)?.ipv4Address;
        if (ip?.includes("/")) {
            ip = ip.slice(0, ip.indexOf("/"));
        }
        newEndpoint.controllingDeviceIp = ip;
        props.onChange(newEndpoint as LuxcomClientEndpoint);
    }, [props, devices]);

    useEffect(() => {
        if ((luxcomEndpoint.controllingDeviceId?.length ?? 0) > 0 || (devices?.length ?? 0) < 1) {
            return;
        }
        const device = devices![0];
        let ip = device.ipv4Address;
        if (ip?.includes("/")) {
            ip = ip.slice(0, ip.indexOf("/"));
        }
        onChange({ ...luxcomEndpoint, controllingDeviceId: device.id, controllingDeviceIp: ip });
    }, [devices, luxcomEndpoint, onChange]);

    const isOffline = props.offlineMode === true;

    return (
        <>
            <InputRow><Input label="Endpoint Name" {...helper.bindingsFor("endpointName", onChange)} /></InputRow>
            <InputRow><Input label="Converter IP" {...helper.bindingsFor("ipAddress",)} /></InputRow>
            {!isOffline && (
                <InputRow><HoverTooltip hoverable={<Select label="Controlling Device" {...helper.bindingsFor("controllingDeviceId", onChangeControllingDevice)} options={deviceOptions} value={luxcomEndpoint.controllingDeviceId} />}>
                    Luxcom will only accept IP traffic from a single address.</HoverTooltip>
                </InputRow>
            )}
            {!isOffline && (
                <InputRow><Input label="Controlling Device IP" {...helper.bindingsFor("controllingDeviceIp", onChange)} /></InputRow>
            )}
            <InputRow><Input label="Command Port" {...helper.bindingsFor("commandPort", onChange)} /></InputRow >
            <InputRow><Input label="Sys Log Port" {...helper.bindingsFor("syslogPort", onChange)} /></InputRow>
            <InputRow><Input label="Forward UDP Port" {...helper.bindingsFor("forwardUdpPort", onChange)} /></InputRow>
        </>
    );
}
